export const RISK_CATEGORIES = ['SOX', 'Compliance', 'Operational', 'Strategic', 'Fraud'];
export const RISK_FILTER_OTHERS = 'Others';

export const DEFAULT_RISK_CATEGORY = 'Operational';

/** Canonical categories for `<select>`s (value and label match). */
export const RISK_CATEGORY_SELECT_OPTIONS = RISK_CATEGORIES.map((value) => ({
  value,
  label: value
}));

export const KNOWN_RISK_CATEGORY_ALIASES = {
  sox: 'SOX',
  'sox risk': 'SOX',
  compliance: 'Compliance',
  'compliance risk': 'Compliance',
  operational: 'Operational',
  'operational risk': 'Operational',
  strategic: 'Strategic',
  'strategic risk': 'Strategic',
  fraud: 'Fraud',
  'fraud risk': 'Fraud',
};

/** Edit form: keep stored value; only default when empty (avoids overwriting unknown categories on open). */
export function getInitialEditRiskCategory(raw) {
  const s = raw == null || raw === '' ? '' : String(raw).trim();
  return s === '' ? DEFAULT_RISK_CATEGORY : s;
}

export function normalizeRiskCategory(raw) {
  const s = raw == null || raw === '' ? '' : String(raw).trim();
  if (!s) return DEFAULT_RISK_CATEGORY;
  if (RISK_CATEGORIES.includes(s)) return s;
  return KNOWN_RISK_CATEGORY_ALIASES[s.toLowerCase()] ?? DEFAULT_RISK_CATEGORY;
}

export function getKnownRiskCategory(raw) {
  const s = raw == null || raw === '' ? '' : String(raw).trim();
  if (!s) return null;
  if (RISK_CATEGORIES.includes(s)) return s;
  return KNOWN_RISK_CATEGORY_ALIASES[s.toLowerCase()] || null;
}

export function getRiskCategoryLabel(raw) {
  const knownCategory = getKnownRiskCategory(raw);
  if (knownCategory) return knownCategory;

  const s = raw == null || raw === '' ? '' : String(raw).trim();
  return s || normalizeRiskCategory(raw);
}

export function isOtherRiskCategory(raw) {
  const s = raw == null || raw === '' ? '' : String(raw).trim();
  return !!s && !getKnownRiskCategory(s);
}

/** Tailwind classes for category pills (must cover every {@link RISK_CATEGORIES} value). */
export const RISK_CATEGORY_BADGE_CLASSES = {
  SOX: 'bg-indigo-100 text-indigo-800',
  Compliance: 'bg-blue-100 text-blue-700',
  Operational: 'bg-teal-100 text-teal-700',
  Strategic: 'bg-slate-100 text-slate-800',
  Fraud: 'bg-purple-100 text-purple-700'
};
